import assign from 'lodash.assign'
//
// ACTION TYPES
//

const CLOSE_MODAL = 'CLOSE_MODAL'
const SHOW_MODAL = 'SHOW_MODAL'

//
// INITIAL STATE
//

const intialState = {
  isActive: false,
  content: null,
  extraClass: null
}

//
// REDUCER
//

export default function modal (state = intialState, action) {
  switch (action.type) {
    case SHOW_MODAL:
      return assign({}, state, {
        isActive: true,
        content: action.newContent || state.content,
        extraClass: action.extraClass
      })
    case CLOSE_MODAL:
      return assign({}, state, {
        isActive: false
      })
    default:
      return state
  }
}

//
// ACTIONS
//

export function closeModal () {
  return { type: CLOSE_MODAL }
}

export function showModal (newContent, extraClass) {
  return {
    type: SHOW_MODAL,
    newContent,
    extraClass
  }
}



// WEBPACK FOOTER //
// ./frontend/scripts/reducers/modal.js